<template>
  <div>
    <b-overlay
      :show="show"
      rounded="sm"
      @shown="onShown"
      @hidden="onHidden"
      variant="white"
      opacity="1.0"
    >
      <div class="load-more-container" :aria-hidden="show ? 'true' : null">
        <b-container style="padding: 1rem">
          <b-button-group class="from-to-btn-group" style="width: 100%">
            <b-button
              variant="outline-secondary"
              block
              style="width: 50%; height: 48px; background: #fff"
              @click="onAddRoute"
            >
              <b-row style="margin-top: -6px">
                <b-col cols="1" style="height: 48px">
                  <b-icon
                    icon="square-fill"
                    variant="info"
                    font-scale="0.5"
                  ></b-icon>
                </b-col>
                <b-col cols="9" style="height: 48px; margin-left: -10px">
                  <!-- <b-form-text class="title-text"> {{ $t('message.from_title') }} </b-form-text> -->
                  <b-form-text
                    class="route-text"
                    v-if="origin !== ''"
                    style="margin-top: 0.5rem"
                  >
                    {{ origin }}
                  </b-form-text>
                  <b-form-text
                    class="placeholder-text"
                    v-if="origin === ''"
                    style="margin-top: 0.5rem"
                  >
                    {{ $t("message.loadig_city") }}
                  </b-form-text>
                </b-col>
              </b-row>
            </b-button>
            <b-button
              variant="outline-secondary"
              style="width: 50%; height: 48px; background: #fff"
              @click="onAddRoute"
            >
              <b-row style="margin-top: -6px">
                <b-col cols="1" style="height: 48px">
                  <b-icon
                    icon="square-fill"
                    variant="secondary"
                    font-scale="0.5"
                  ></b-icon>
                </b-col>
                <b-col cols="9" style="height: 48px; margin-left: -10px">
                  <!-- <b-form-text class="title-text"> {{ $t('message.to_title') }} </b-form-text> -->
                  <b-form-text
                    class="route-text"
                    v-if="destination !== ''"
                    style="margin-top: 0.5rem"
                  >
                    {{ destination }}
                  </b-form-text>
                  <b-form-text
                    class="placeholder-text"
                    v-if="destination === ''"
                    style="margin-top: 0.5rem"
                  >
                    {{ $t("message.unLoading_city") }}
                  </b-form-text>
                </b-col>
              </b-row>
            </b-button>
          </b-button-group>
          <RouteModal
            @add-route="add_Route"
            :routes_list="routes_list"
            type="multiple"
          />
        </b-container>
        <b-container class="demand-details-container">
          <div style="text-align: center" v-if="showPageLoader">
            <b-spinner
              style="width: 3rem; height: 3rem"
              label="Large Spinner"
            ></b-spinner>
          </div>
          <DemandDetailsCard
            v-for="(demand, idx) in demandDetails"
            v-bind:key="idx"
            :item="demand"
            @click-bid-now="openDemandDetailsModal"
          />
          <div
            v-if="demandDetails.length"
            v-observe-visibility="getMoreDemandList"
          ></div>
          <div
            v-if="demandDetails.length === 0 && !showPageLoader"
            style="margin-top: 20%"
          >
            <NoresultsFound route="load_market" />
          </div>
          <b-row
            v-if="demandDetails.length === 0 && !showPageLoader"
            class="btn-fixed-bottom-route"
          >
            <b-col>
              <b-button
                type="submit"
                variant="outline-dark"
                block
                @click="truckAvailability"
              >
                {{ $t("message.haveTrucksAlert") }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
        <DemandDetailsModal
          :item="currentItem"
          @update-demand-list="updateDemandStatus"
          @user-login="login"
        />
      </div>
      <template #overlay class="over-login">
        <div v-if="screen === 'login'">
          <Login @submit-login="handleLogin" @handle-close="handleClose" />
        </div>
        <div v-if="screen === 'register'">
          <Register
            @submit-register="handleRegister"
            @handle-close="handleClose"
            :item="selectedBid"
            :hash_id="hash_id"
            :contact="mobileNumber"
          />
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import RouteModal from "../components/modals/LoadRouteModal.vue";
import DemandDetailsCard from "../components/DemandDetailsCard.vue";
import DemandDetailsModal from "../components/modals/DemandDetailsModal.vue";
import NoresultsFound from "../components/modals/NoresultsFound.vue";
import Login from "./Login";
import Register from "./Register";
// import StatusBanner from '../components/StatusBanner.vue'

import axios from "axios";
import { MX_TRACK } from "../utils/Mixpanel.js";
const Hotjar = require("../utils/Hotjar.js");

import config from "../config/config.js";

const API_BASE_URL = process.env.VUE_APP_API_GATEWAY_BASE_URL;

export default {
  name: "OpenLoads",
  components: {
    RouteModal,
    DemandDetailsCard,
    DemandDetailsModal,
    NoresultsFound,
    Login,
    Register,
    // StatusBanner,
  },
  data() {
    return {
      showRouteModal: false,
      showLoader: false,
      show: false,
      routes_list: [],
      routes_dup: {},
      showSaveBtnLoader: false,
      showPageLoader: true,
      origin: "",
      destination: "",
      screen: "login",
      demandDetail: {},
      demandDetails: [],
      currentItem: {},
      pagination: {
        total: 0,
        pageSize: 10,
        currentPage: 0,
        searchAfter: null,
      },
      pageSize: 10,
      currentPage: 0,
      selectedBid: {},
      hash_id: "",
      reqData: {},
      mobileNumber: "",
    };
  },
  methods: {
    handleClose() {
      this.show = false;
    },
    async handleLogin(mobileNumber) {
      // console.log("selected_bid",this.selectedBid.demand_id)
      const { data } = await axios.get(
        `supplier/${mobileNumber}?demand_id=${this.selectedBid.demand_id}`
      );
      if (data.success) {
        if (data.value.registered) {
          this.getDemandDetails(data.value.hash_id);
          const body = this.reqData;
          const headers = {
            "Content-Type": "application/json",
          };
          console.log("body_123", JSON.stringify(body));
          try {
            const response = await axios.post(
              `/bid/place/${data.value.hash_id}`,
              body,
              { headers }
            );
            console.log("response", JSON.stringify(response));
            this.trackMixpanelEvent(config.MIXPANEL_EVENTS.LOGIN_BID_SUBMIT);
            localStorage.setItem("demand_supply_id", data.value.hash_id);
            this.$router.push(
              `/${this.$route.params.lang}/load_market/${data.value.hash_id}`
            );
          } catch (error) {
            this.toast(
              "danger",
              "b-toaster-bottom-center",
              this.$t("message.placeBidFailedText"),
              true
            );
            localStorage.setItem("demand_supply_id", data.value.hash_id);
            this.$router.push(
              `/${this.$route.params.lang}/load_market/${data.value.hash_id}`
            );
          }
        } else {
          this.screen = "register";
          this.mobileNumber = mobileNumber;
          console.log("hash_id", data.value.hash_id);
          this.hash_id = data.value.hash_id;
          MX_TRACK(config.MIXPANEL_EVENTS.OPEN_REGISTER_PAGE, {
            demand_id: this.selectedBid.demand_id,
          });
        }
      }
    },
    async getDemandDetails(id) {
      const response = await axios.get(
        `${process.env.VUE_APP_API_GATEWAY_BASE_URL}/demand/details/${id}`
      );
      this.$store.commit("updateDemandDetails", response.data);
    },
    async handleRegister(data) {
      this.getDemandDetails(data.value);
      const body = this.reqData;
      const headers = {
        "Content-Type": "application/json",
      };
      console.log("body_123", JSON.stringify(body));
      try {
        const response = await axios.post(`/bid/place/${data.value}`, body, {
          headers,
        });
        console.log("response", JSON.stringify(response));
        this.trackMixpanelEvent(config.MIXPANEL_EVENTS.LOGIN_BID_SUBMIT);
        localStorage.setItem("demand_supply_id", data.value);
        this.$router.push(
          `/${this.$route.params.lang}/load_market/${data.value}`
        );
      } catch (error) {
        this.toast(
          "danger",
          "b-toaster-bottom-center",
          this.$t("message.placeBidFailedText"),
          true
        );
        localStorage.setItem("demand_supply_id", data.value);
        this.$router.push(
          `/${this.$route.params.lang}/load_market/${data.value}`
        );
      }
    },
    onShown() {
      // Focus the cancel button when the overlay is showing
      // this.$refs.cancel.focus()
    },
    onHidden() {
      // Focus the show button when the overlay is removed
      //this.$refs.show.focus()
    },
    truckAvailability() {
      //this.trackMixpanelEvent(config.MIXPANEL_EVENTS.ON_CLICK_TRUCK_AVAILABILITY)
      this.$router.push(
        `/${this.$route.params.lang}/truck_availability/${this.$route.params.id}`
      );
    },
    async onAddRoute() {
      this.$root.$emit("on-add-route", null);
    },
    add_Route(route) {
      this.routes_list = route;
      this.routes_dup = route;
      this.origin = route.origin;
      this.destination = route.destination;
      this.demandDetails = [];
      this.currentPage = 0;
      this.pagination = {
        total: 0,
        pageSize: 10,
        currentPage: 0,
        searchAfter: null,
      };
      this.getDemadDetails();
      //
      //this.unLoadingPointOptions = unLoadingPointOptions
    },
    getMoreDemandList(isVisible) {
      if (isVisible && this.demandDetails.length < this.pagination.total) {
        this.currentPage += 1;
        this.getDemadDetails();
      }
    },
    openDemandDetailsModal(item) {
      this.currentItem = item;
      this.$bvModal.show("ft-demand-details-modal");
      const mx_prop = {
        user_type: item.user_type,
        user_name: item.supplier_name,
        phone_number: item.contact,
        language: this.$route.params.lang,
        demand_id: item.demand_id,
        demand_status: item.demand_status,
        bid_status: item.status,
        time: new Date().getTime(),
        user_id: item.supplier_id,
        page_src: this.$route.name,
        vehicle_count: item.trucks_required,
        template: this.$route.params.template || "",
      };
      MX_TRACK(config.MIXPANEL_EVENTS.PAGE_LOAD, mx_prop);
      Hotjar.IDENTIFY_FO_APP(this, item.supplier_id, mx_prop);
    },
    async getDemadDetails(isDefault = false) {
      try {
        const pageNo = isDefault ? 0 : this.currentPage;
        //http://ib-phase2-poc-service.qa.freighttiger.com/supplier/load_market?page=0&size=20
        // const {data} = await axios.get(`${API_BASE_URL}/supplier/${this.$route.params.id}/load_market?page=${pageNo}&size=${this.pageSize}`)
        console.log(
          "url_123__",
          `${API_BASE_URL}/supplier/load_market?page=${pageNo}&size=${this.pageSize}`
        );
        let url = `${API_BASE_URL}/supplier/load_market?page=${pageNo}&size=${this.pageSize}`;
        console.log("url_123__", url);
        if (this.origin !== "") {
          url =
            url +
            `&origin_place_id=${this.routes_list.origin_place_id}&origin_label=${this.routes_list.origin}`;
        }
        if (this.destination !== "") {
          url =
            url +
            `&destination_place_id=${this.routes_list.destination_place_id}&destination_label=${this.routes_list.destination}`;
        }

        console.log("url_+123", url);

        const { data } = await axios.get(url);
        console.log("data_123", JSON.stringify(data));
        this.pagination = data.pagination;
        // data.value[0].demand_status_details = {status: "OPEN", rate: 1222, trucks_supplied: 1, winning_bid: null}

        this.demandDetails = isDefault
          ? data.value
          : [...this.demandDetails, ...data.value];
        console.log("demandDetails_123", JSON.stringify(this.demandDetails));
      } catch (error) {
        console.log(error);
      }
      this.showPageLoader = false;
    },
    updateDemandStatus(id, data) {
      const demands = [...this.demandDetails];
      demands.find((demand, idx) => {
        if (demand.unique_id == id) {
          demands[idx].demand_status_details = data.value;
          return;
        }
      });
    },
    login(item, data) {
      //alert("login")
      this.show = true;
      this.selectedBid = item;
      console.log("data_123", JSON.stringify(data));
      this.reqData = data;
    },
    trackMixpanelEvent(event, data = {}) {
      const demandDetails = this.$store.getters.getDemandDetails.value;
      const mx_prop = {
        time: new Date().getTime(),
        page_src: this.$route.name,
        user_type: demandDetails.user_type,
        user_name: demandDetails.supplier_name,
        phone_number: demandDetails.contact,
        language: this.$route.params.lang,
        demand_id: demandDetails.demand_id,
        bid_status: demandDetails.status,
      };
      MX_TRACK(event, { ...mx_prop, ...data });
    },
    cacheId() {
      if (this.$route.params.id) {
        localStorage.setItem("demand_supply_id", this.$route.params.id);
      }
    },
    toast(variant, toaster, text, append = false) {
      this.$bvToast.toast(text, {
        toaster: toaster,
        solid: true,
        variant: variant,
        appendToast: append,
        noCloseButton: true,
      });
    },
  },
  mounted() {
    let id = localStorage.getItem("demand_supply_id");
    if (id != "undefined" && id != "null" && id != null) {
      this.$router.push(`/${this.$route.params.lang}/load_market/${id}`);
    } else {
      this.getDemadDetails(true);
      this.cacheId();
      const routeData = {
        routeName: this.$route.name,
        lng: this.$route.params.lang,
        demandId: this.$route.params.id,
      };
      this.$store.dispatch("swWorkerInitialized", routeData);
    }
  },
  watch: {
    "$store.state.demandDetails": {
      immediate: true,
      handler() {
        this.demandDetail = this.$store.getters.getDemandDetails;
      },
    },
  },
  computed: {
    getSupplierName() {
      return this.demandDetail.value.supplier_name;
    },
  },
};
</script>

<style lang="scss">
.load-more-container {
  background-color: #e5e5e5;
  min-height: 500px;
}
.b-overlay {
  .position-absolute {
    top: 0% !important;
    left: 0% !important;
    transform: translateX(0%) translateY(0%) !important;
    width: 100%;
    padding-top: 10%;
  }
}

.load-more-container {
  margin-top: 80px;
  height: 100%;
}

.ui-confirmdialog-message {
  white-space: pre-line;
}

.btn-fixed-bottom-route {
  margin-bottom: 10px;
}
.btn-outline-dark {
  /* color: #343a40; */
  color: #3094fc;
}
// .btn-fixed-bottom {
//             position: fixed;
//             bottom: 0;
//             width: 100%;
//             background-color: white;
//             z-index: 5;
//             padding-top:20px;
//             padding-bottom:20px;
//             margin-bottom: 0px;
//         }

@media (max-width: 576px) {
  .demand-details-container {
    padding: 0;
    overflow-y: auto;
    min-height: 750px;
    max-height: 850px;
    padding-bottom: 50px;
  }

  .load-more-container {
    margin-top: 66px;
    // margin-bottom: 100px;
  }

  .btn-fixed-bottom-route {
    position: fixed;
    bottom: 0;
    width: 100%;
    // align-self: center;
    margin-left: 1.5%;
    //background-color: white;
    z-index: 5;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 0px;
  }
  // margin-bottom: 10px;
}
.route-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
}
.placeholder-text {
  text-align: left;
}
.title-text {
  text-align: left;
}
</style>
